import type { AdUnitTargetingParams } from 'src/routes/admin/components/pages/Story/CardEditor/Inspector/AdUnitSettings/types';

export function parseAdUnitTargetingParams(paramsStr: string): AdUnitTargetingParams {
	try {
		const parsedParams = JSON.parse(paramsStr);
		return Array.isArray(parsedParams) ? parsedParams : [];
	} catch {
		return [];
	}
}
